module.exports = __webpack_public_path__ + "img/26.fd0a2784.jpg";